import {
  SET_OPERATIONAL_EXPENSES,
  SET_OPERATIONAL_EXPENSE_ACTION_LOADING,
  SET_OPERATIONAL_EXPENSE_DETAIL,
  SET_OPERATIONAL_EXPENSE_ERROR,
  SET_OPERATIONAL_EXPENSE_LOADING,
} from "../../actions/operationalExpenseAction";

const initialState = {
  data: null,
  detail: null,
  loading: false,
  actionLoading: false,
  error: null,
};

const operationalExpenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPERATIONAL_EXPENSES:
      return { ...state, data: action.data, error: null };
    case SET_OPERATIONAL_EXPENSE_DETAIL:
      return { ...state, detail: action.data, error: null };
    case SET_OPERATIONAL_EXPENSE_LOADING:
      return { ...state, loading: action.status };
    case SET_OPERATIONAL_EXPENSE_ACTION_LOADING:
      return { ...state, actionLoading: action.status };
    case SET_OPERATIONAL_EXPENSE_ERROR:
      return { ...state, error: action.error, loading: false, actionLoading: false };
    default:
      return state;
  }
};

export default operationalExpenseReducer;
